import find from 'lodash/find';
import { getDecodedLibraryList } from 'selectors/libraries/list';
import { getLoggedInUserProfile } from 'selectors/loggedInUser';

const actionPrefix = 'libraries';

export const LIBRARY_MODAL_CLOSE = `${actionPrefix}/LIBRARY_MODAL_CLOSE`;
export const LIBRARY_MODAL_ADD_NEW = `${actionPrefix}/LIBRARY_MODAL_ADD_NEW`;
export const LIBRARY_MODAL_SELECT = `${actionPrefix}/LIBRARY_MODAL_SELECT`;
export const LIBRARY_MODAL_NAME_CHANGE = `${actionPrefix}/LIBRARY_MODAL_NAME_CHANGE`;
export const LIBRARY_MODAL_CODE_CHANGE = `${actionPrefix}/LIBRARY_MODAL_CODE_CHANGE`;
export const LIBRARY_MODAL_CLEAN = `${actionPrefix}/LIBRARY_MODAL_CLEAN`;

export const OPEN_LIBRARIES_DIALOG = `${actionPrefix}/OPEN_DIALOG`;
export const CLOSE_LIBRARIES_DIALOG = `${actionPrefix}/CLOSE_DIALOG`;

export const DELETE_LIBRARY = `${actionPrefix}/DELETE_LIBRARY`;
export const DELETE_LIBRARY_START = `${DELETE_LIBRARY}_START`;
export const DELETE_LIBRARY_SUCCESS = `${DELETE_LIBRARY}_SUCCESS`;
export const DELETE_LIBRARY_FAIL = `${DELETE_LIBRARY}_FAIL`;

export const closeLibrary = modalId => ({
  type: LIBRARY_MODAL_CLOSE,
  payload: { modalId },
});

export const addNewLibrary =
  (modalId, defaultName, initialScript) => (dispatch, getState) =>
    dispatch({
      type: LIBRARY_MODAL_ADD_NEW,
      payload: {
        modalId,
        defaultName,
        initialScript,
        owner: getLoggedInUserProfile(getState()),
      },
    });

export const selectLibrary = (modalId, id) => (dispatch, getState) =>
  dispatch({
    type: LIBRARY_MODAL_SELECT,
    payload: {
      modalId,
      library: find(getDecodedLibraryList(getState()), ['id', id]),
    },
  });

export const changeLibraryName = (modalId, name) => ({
  type: LIBRARY_MODAL_NAME_CHANGE,
  payload: { modalId, name },
});

export const changeLibraryCode = (modalId, script) => ({
  type: LIBRARY_MODAL_CODE_CHANGE,
  payload: { modalId, script },
});

export const cleanModalState = modalId => ({
  type: LIBRARY_MODAL_CLEAN,
  payload: { modalId },
});

export const openModal = modalId => ({
  type: OPEN_LIBRARIES_DIALOG,
  payload: { modalId },
});

export const closeModal = modalId => ({
  type: CLOSE_LIBRARIES_DIALOG,
  payload: { modalId },
});

export const deleteLibrary = (modalId, id) => ({
  type: DELETE_LIBRARY,
  payload: { modalId },
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/libraries/${id}`,
    method: 'del',
  },
});
